module.exports = __webpack_public_path__ + "img/pota-1.0b50decc.png";